import { StrictNullable, Location } from 'core/types';
import { usePlaceAutocomplete } from 'hooks/use-place-autocomplete';
import { useState } from 'react';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';

export type LocationValue = StrictNullable<Location>;

type LocationFieldProps = {
	value?: LocationValue;
	onChange?: (value: LocationValue) => void;
	placeholder?: string;
	fullWidth?: boolean;
	disabled?: boolean;
};

export const LocationField = (props: LocationFieldProps) => {
	const { onChange, placeholder, fullWidth, disabled } = props;
	const [error, setError] = useState<string | null>(null);

	const { containerRef } = usePlaceAutocomplete({
		onPlaceSelected: location => {
			setError(null);
			onChange?.(location);
		},
		onError: () => {
			setError('Failed to get location details. Please try again.');
		},
		placeholder,
	});

	return (
		<Box
			data-test-id='location-field'
			sx={{ width: fullWidth ? '100%' : undefined }}
		>
			<Box
				ref={containerRef}
				sx={{
					opacity: disabled ? 0.5 : 1,
					pointerEvents: disabled ? 'none' : undefined,
					'& gmp-place-autocomplete': {
						display: 'block',
						width: '100%',
						colorScheme: 'light',
					},
					'& gmp-place-autocomplete::part(input-container)': {
						border: '1px solid #2b1914',
						borderRadius: '4px',
						backgroundColor: '#ffffff',
					},
					'& gmp-place-autocomplete::part(input)': {
						fontFamily: "'Proxima Nova', sans-serif",
						fontSize: '16px',
						lineHeight: '20px',
						padding: '12px 16px',
						outline: 'none',
						width: '100%',
						boxSizing: 'border-box',
						color: '#2b1914',
						backgroundColor: 'transparent',
					},
					'& gmp-place-autocomplete:focus-within::part(input-container)':
						{
							borderStyle: 'dashed',
							borderColor: '#2b1914',
						},
				}}
			/>
			{error && (
				<FormHelperText error sx={{ mt: 1 }}>
					{error}
				</FormHelperText>
			)}
		</Box>
	);
};
